module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.list), function(item, i) {
    return _c('dof-radio-item', _vm._b({
      key: i,
      attrs: {
        "config": _vm.config,
        "data-evt-dofRadioItemChecked": ""
      },
      on: {
        "dofRadioItemChecked": function($event) {
          return _vm.dofRadioItemChecked(i, $event)
        }
      }
    }, 'dof-radio-item', item, false))
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-85989c14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85989c14","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio/index.vue
// module id = 640
// module chunks = 0 1